import { gql, useQuery } from '@apollo/client';

import { useGetCurrentCompany } from 'src/hooks/companies/get-current-company.hook';

export const GET_CURRENT_SUBSCRIPTION = gql`
  query ($subscriptionId: String!) {
    getCurrentSubscription(subscriptionId: $subscriptionId) {
      _id
      subscriptionType
      maxCustomerRange
      status
      trialEndAt
      trialPeriod
      stripeSubscriptionId
      totalPrice
      recurringType
      softwarePlan {
        name
        refModuleName
        currency
      }
      paymentMethod {
        exp_month
        exp_year
        accountHolderName
        ibanNumber
        email
        cardNumber
      }
      usedEmployeesPlacesCount
      allowedEmployeesAddition
    }
  }
`;

export const SUBSCRIPTION_CHANGED_SUBSCRIPTION = gql`
  subscription subscriptionChanged($subscriptionId: String!) {
    subscriptionChanged(subscriptionId: $subscriptionId) {
      _id
      subscriptionType
      maxCustomerRange
      status
      trialEndAt
      trialPeriod
      stripeSubscriptionId
      totalPrice
      recurringType
      softwarePlan {
        name
        refModuleName
        currency
      }
      paymentMethod {
        exp_month
        exp_year
        accountHolderName
        ibanNumber
        email
        cardNumber
      }
      usedEmployeesPlacesCount
      allowedEmployeesAddition
    }
  }
`;

export const useGetCurrentSubscription = ({ skipSubscription = false } = {}) => {
  const { company, loading } = useGetCurrentCompany();
  const { data, subscribeToMore } = useQuery(GET_CURRENT_SUBSCRIPTION, {
    variables: { subscriptionId: company.subscriptionId },
    skip: loading || !Object.keys(company).length,
  });

  if (!loading && company.subscriptionId && !skipSubscription) {
    subscribeToMore({
      document: SUBSCRIPTION_CHANGED_SUBSCRIPTION,
      variables: { subscriptionId: company.subscriptionId },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data) return prev;

        return { getCurrentSubscription: subscriptionData.data.subscriptionChanged };
      },
    });
  }

  return { subscription: data?.getCurrentSubscription || {}, loading };
};
